import { createMachine } from 'xstate';
import { useMemo } from 'react';
import { useMachine } from '@xstate/react';

import {
  machineConfig,
} from './config/index';
import { actions } from './config/actions';
import { guards } from './config/guards';
import { services as defaultServices } from './config/services';

export function useSuggestionsService(serviceConfig) {
  const machine = useMemo(() => createMachine(machineConfig, {
    actions,
    guards,
  }), []);
  const machineWithServiceConfig = useMemo(() => machine.withConfig({
    services: {
      ...defaultServices,
      ...serviceConfig,
    },
  }), [machine, serviceConfig]);
  const [state, send, service] = useMachine(machineWithServiceConfig);

  const result = useMemo(() => ({
    state,
    send,
    service,
  }), [send, service, state]);

  return result;
}
